export const POS_PATH = '/pos';
